import application from 'application/application';

application
	.factory('preventTemplateCache', ['$injector', ($injector) => {
		var { version } = $injector.get('environment');

		return {
			'request': function(config) {
				if (config.url.indexOf('templates') !== -1) {
					config.url = config.url + '?v=' + version;
				}

				return config;
			}
		};
	}]);
